import React, { Component } from 'react';
import Iframe from 'react-iframe'
import { withTranslation, Trans } from 'react-i18next';
import { InlineShareButtons } from 'sharethis-reactjs';
import NewHeader from './NewHeader';
import NewFooter from './NewFooter';
import NumberFormat from 'react-number-format';
import DocumentMeta from 'react-document-meta';
class detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      markets: [],
      NewsperPage: 3,
      cryptoId: this.props.match.params.id,
      live_api_url: 'http://161.97.164.249:5000/detail/',
      api_url: 'http://161.97.164.249:5000',
      uploaded_image_url: 'http://161.97.164.249/cryptoawaj/public/images/',
    };
    this.loadMoreNews = this.loadMoreNews.bind(this);
    // this.changePageCurrency = this.changePageCurrency.bind(this);
    this.saveAdDetail = this.saveAdDetail.bind(this);
    // this.changeLanguage = this.changeLanguage.bind(this);
    this.setTimeZone = this.setTimeZone.bind(this);
    this.get_total_news = this.get_total_news.bind(this);
  }

  componentDidMount() {
    //this.changePageCurrency('');
    // this.loadCurrencyDropdown();
    this.RightAd();
    this.getLatestNews();
    this.setTimeZone();
    this.loadPage('USD')
    this.getMarkets(this.state.cryptoId, 'USD');
    this.setState({ showCurrency: 'USD' })
    this.get_total_news();
  }


  setTimeZone() {
    let timezone_value = - new Date().getTimezoneOffset() * 60
    fetch(this.state.api_url + '/save_timezone/' + timezone_value, { method: "get" })
      .then((res) => res.json())
      .then((data) => {
      })
      .catch(err => console.log(err))
  }


  get_total_news() {
    fetch(this.state.api_url + '/get_total_news', { method: "get" })
      .then((res) => res.json())
      .then((total_news_length) => {
        this.setState({ total_news_length })
      })
      .catch(err => console.log(err))
  }

  saveAdDetail(id) {
    fetch(this.state.api_url + '/save_ad_detail/' + id, { method: "get" })
      .then((res) => res.json())
      .then((data) => {
      })
      .catch(err => console.log(err))
  }

  // getExchnagePair(markets, currency) {
  //   // console.log(markets);
  //   fetch(this.state.api_url + '/getExchnagePair/' + markets.symbol + '/' + currency, { method: "get" })
  //     .then((res) => res.json())
  //     .then((pairdata) => {
  //       console.log('Paired Data');
  //       console.log(pairdata);
  //       const pairdataresult = pairdata.map((pd, index) =>
  //         <tr key={index}><td>{pd.exchange}</td><td>{pd.pairs}</td><td><NumberFormat value={parseInt(pd.volume_in_usd)} displayType={'text'} thousandSeparator={true} prefix={pd.volume_sym + ' '} renderText={value => value} /></td><td><NumberFormat value={pd.price_in_usd} displayType={'text'} thousandSeparator={true} prefix={pd.price_sym + ' '} renderText={value => value} />

  //         </td></tr>
  //       );
  //       this.setState({ pairdataresult })
  //     })
  //     .catch(err => console.log(err))

  // }

  loadWidget(markets) {
    let widgeturl = this.state.api_url + "/widget_chart/" + markets.widget_symbol
    this.setState({ widgeturl })
  }

  getMarkets(crypto_symbol, currency) {
    fetch(this.state.api_url + '/get_markets/' + crypto_symbol + '/' + currency, { method: "get" })
      .then((res) => res.json())
      .then((data) => {
        const my_markets = data.map((pd, index) =>
          <li key={index}>
            <span>{pd.market_name}</span>
            <span>{pd.total_volume}</span>
            <span>{pd.total_price}</span>
          </li>
        )
        this.setState({ my_markets })
      })
      .catch(err => console.log(err))
  }


  RightAd() {
    fetch(this.state.api_url + '/getAdvertisement/R', { method: "get" })
      .then((res) => res.json())
      .then((data) => {
        const rightAdData = data.map((pd, index) => {
          return pd.type === 'M' ?
            <a key={index} href={pd.link} onClick={() => this.saveAdDetail(pd.id)} target="_blank" rel="noopener noreferrer"><img src={this.state.uploaded_image_url + pd.image} alt="Img" className="img-fluid" /> </a>

            : pd.body

        }
        );
        this.setState({ rightAdData })
      })
      .catch(err => console.log(err))
  }


  loadMoreNews() {
    let curPerPage = this.state.NewsperPage + 3
    this.setState({ NewsperPage: curPerPage })
    fetch(this.state.api_url + '/get_latest_news/' + curPerPage, { method: "get" })
      .then((res) => res.json())
      .then((latestnews) => {
        const latestnewsData = latestnews.map((pd, index) =>
          <div className="col-lg-4 col-md-6 col-sm-6 pulldevice" key={index}>
            <div className="news-list wow bounceInUp" data-wow-delay="0.4s">
              <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} className="news-img" target="_blank" rel="noopener noreferrer">
                <img src={this.state.uploaded_image_url + pd.image} alt="" width="373" height="291" className="img-fluid" />
              </a>
              <div className="news-inner">
                <div className="time-box">{pd.created}</div>
                <h4><a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer">{pd.title}</a></h4>
                <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer" className="authore">{pd.author_name}</a>
              </div>
            </div>
          </div>

        )
        this.setState({ latestnewsData, 'current_news_length': latestnews.length })
      })
      .catch(err => console.log(err))
  }


  getLatestNews() {
    let curPerPage = this.state.NewsperPage
    this.setState({ NewsperPage: curPerPage })
    fetch(this.state.api_url + '/get_latest_news/' + curPerPage, { method: "get" })
      .then((res) => res.json())
      .then((latestnews) => {
        const latestnewsData = latestnews.map((pd, index) =>
          <div className="col-lg-4 col-md-6 col-sm-6 pulldevice" key={index}>
            <div className="news-list wow bounceInUp" data-wow-delay="0.4s">
              <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} className="news-img" target="_blank" rel="noopener noreferrer">
                <img src={this.state.uploaded_image_url + pd.image} alt="" width="373" height="291" className="img-fluid" />
              </a>
              <div className="news-inner">
                <div className="time-box">{pd.created}</div>
                <h4><a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer">{pd.title}</a></h4>
                <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer" className="authore">{pd.author_name}</a>
              </div>
            </div>
          </div>);
        this.setState({ latestnewsData, 'current_news_length': latestnews.length })
      })
      .catch(err => console.log(err))
  }



  loadPage(paisa) {
    this.setState({ showCurrency: paisa })
    fetch(this.state.api_url + '/getDetail/' + this.state.cryptoId + '/' + paisa, { method: "get" })
      .then((res) => res.json())
      .then((markets) => {
        // console.log(markets);
        document.title = markets.symbol_upper + ': ' + markets.price.replace('USD ', '$') + ' Price, Chart, News'
        let iframeurl = this.state.api_url + "/detail_chart/" + markets.slug + '/' + paisa
        this.setState({ markets })
        this.setState({ iframeurl })
        // this.getExchnagePair(markets, paisa);
        this.loadWidget(markets);
      })
      .catch(err => console.log(err))


  }
  render() {
    const _markets = this.state.markets;
    // console.log(_markets);
    const pageurl = this.state.live_api_url + this.state.cryptoId
    const lang = localStorage.getItem('lang') || 'en'
    const imageUri = "http://cryptop2p.in/public/img/app-icon2.png";
    const meta = {
      meta: {
        property: {
          'og:url': pageurl,
          'og:image': imageUri,
        }
      }
    };
    return (
      <section className="mid-section">

        <DocumentMeta {...meta} />
        <NewHeader title={this.state.cryptoId} />
        <div className="container">
          <div className="top-action-div">
            <div className="web-change-div">&nbsp;</div>
            <div className="clearfix">&nbsp;</div>
            <div className="clearfix">&nbsp;</div>
            <div className="clearfix">&nbsp;</div>
            <div className="clearfix">&nbsp;</div>
          </div>
          <div className="top-action-div listname"><a href="/"><h5> <i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Markets</h5></a></div>


          <div className="detail-top-head">
            <div className="detail-company-name">
              {
                _markets.coin_image !== '' &&
                <img alt="" src={this.state.uploaded_image_url + _markets.image} style={{ 'width': '36px', 'height': '34px' }} />
              }
              {
                _markets.coin_image === '' &&
                <img alt="" src={this.state.uploaded_image_url + _markets.image} style={{ 'width': '36px', 'height': '34px' }} />
              }

              <h1>{_markets.name}</h1> &nbsp;
              <span className={(_markets.percent_change_24h > 0 ? 'table-precentage high' : 'table-precentage low')}>({_markets.percent_change_24h}%)</span>

            </div>
          </div>

          <div className="detail-top-head-sub">

            <div className="market-cap">
              <h5>
                <Trans>Market Cap</Trans>
              </h5>
              <div className="btc-name">{_markets.market_cap} </div>
            </div>

            <div className="market-cap">
              <h5>
                CMC <Trans>Rank</Trans>
              </h5>
              <div className="btc-name">{_markets.cmc_rank} </div>
            </div>



            <div className="detail-top-doller"><NumberFormat value={_markets.price} displayType={'text'} thousandSeparator={true} prefix={'USD '} renderText={value => value} /></div>

            <div className="market-cap">
              <h5>
                <Trans>Circulating Supply</Trans>
              </h5> <div className="btc-name">{_markets.symbol_upper} <NumberFormat value={parseInt(_markets.total_supply)} displayType={'text'} thousandSeparator={true} renderText={value => value} />  </div>
            </div>
            <div className="market-cap">
              <h5>
                <Trans>24hr Volume</Trans>

              </h5>
              <div className="btc-name">{_markets.volume_24h}</div>
            </div>

          </div>
          <div className="detail-top-head-btn">
            <a href={_markets.trade_url} className="btn btn-primary btn-midium" target="_blank" rel="noopener noreferrer"><span><Trans>Trade</Trans> {_markets.name}</span></a>
            <a href={_markets.earn_url} className="btn btn-primary btn-midium" target="_blank" rel="noopener noreferrer"><span><Trans>Earn</Trans> {_markets.name}</span></a>
          </div>
          <div className="clearfix">&nbsp;</div>
          <div className="currencies-favaourites">
            <table className="table table-responsive"><tbody><tr><td><h4>{_markets.symbol_upper} / USD : Price Chart</h4></td></tr></tbody></table>
            <div className="row">

              <div className="col-xl-10 col-lg-9">
                <div className="holds-the-iframe" style={{ 'backgroundColor': 'rgb(42 42 42)' }}>
                  <Iframe url={this.state.iframeurl}
                    width="980px"
                    height="480px"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative" frameBorder="0" />
                </div>
                <div className="clearfix">&nbsp;</div>

                <div className="social-div"></div>
                <InlineShareButtons
                  config={{
                    alignment: 'left',
                    color: 'social',
                    enabled: true,
                    font_size: 16,
                    labels: 'cta',
                    language: 'en',
                    networks: [
                      'facebook',
                      'twitter',
                      'telegram',
                      'linkedin',
                      'reddit'
                    ],
                    padding: 12,
                    radius: 4,
                    show_total: false,
                    size: 30,

                    url: pageurl,
                    image: imageUri,
                    description: 'Every news related to bitcoin is covered by Crypto P2P Exchange',
                    message: '',
                    subject: '',
                    username: 'Team Crypto P2P Exchange'
                  }}
                />
                <div className="tether-boxs">
                  <div className="row">

                    <div className="col-lg-6 col-lg-6">
                      <h6>{_markets.name} <Trans>Stats</Trans></h6>
                      <dl>
                        <dt>
                          <Trans>Rank</Trans>


                        </dt>

                        <dd>{_markets.cmc_rank}</dd>

                        <dt>
                          <Trans>Price</Trans>


                        </dt>

                        <dd><NumberFormat value={_markets.price} prefix={'USD '} displayType={'text'} thousandSeparator={true} renderText={value => value} /> </dd>

                        <dt>
                          <Trans>Market Cap</Trans>


                        </dt>

                        <dd>{_markets.market_cap}</dd>

                        <dt>
                          <Trans>24hr Volume</Trans>


                        </dt>

                        <dd>{_markets.volume_24h}</dd>

                      </dl>
                    </div>

                    <div className="col-lg-6 col-lg-6 tether-meta">
                      <h6>{_markets.name} <Trans>Meta</Trans></h6>
                      <dl>
                        <dt>
                          <Trans>Algorithm</Trans>


                        </dt>

                        <dd>{(_markets.algorithm !== null) ? _markets.algorithm : '-'} </dd>

                        <dt>
                          <Trans>Proof Type</Trans>


                        </dt>

                        <dd>{(_markets.proof_type !== null) ? _markets.proof_type : '-'} </dd>

                        <dt>
                          <Trans>Circulating Supply</Trans>


                        </dt>

                        <dd><NumberFormat value={parseInt(_markets.total_supply)} displayType={'text'} thousandSeparator={true} renderText={value => value} /> {_markets.symbol_upper}</dd>

                        {_markets.max_supply !== 'None' &&
                          <dt>
                            <Trans>Max Supply</Trans>
                          </dt>
                        }

                        {_markets.max_supply > 0 &&

                          <dd>{(_markets.max_supply !== 'None') ? <NumberFormat value={parseInt(_markets.max_supply)} displayType={'text'} thousandSeparator={true} renderText={value => value} /> : '-'} {_markets.symbol_upper}</dd>
                        }

                        {_markets.max_supply === 'None' || _markets.max_supply === '' &&

                          <dd>∞</dd>
                        }

                      </dl>
                    </div>

                  </div>
                </div>

              </div>

              <div className="col-xl-2 col-lg-3  hide-ipad">
                {this.state.rightAdData}
              </div>

            </div>
          </div>

          <div className="clearfix">&nbsp;</div>
          <div className="clearfix">&nbsp;</div>
          {/* <div className="token-summery">
            <h5><Trans>{_markets.name} Market Pairs</Trans></h5>
            <p><Trans>Interesting on-chain metrics that provide a rapid understanding </Trans></p>

            <div className="row">
              {_markets.widget_symbol !== 'no' &&
                <div className="col-lg-7 col-md-12">
                  <div className="table-responsive">
                    <table className="table table-bordered" style={{ 'minWidth': '500px' }}>
                      <tr>
                        <th>Exchange</th>
                        <th>Pair</th>
                        <th>Volume</th>
                        <th>Price</th>
                      </tr>
                      {this.state.pairdataresult}

                    </table>
                  </div>
                </div>
              }

              {_markets.widget_symbol === 'no' &&
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table table-bordered" style={{ 'minWidth': '500px' }}>
                      <tr>
                        <th>Exchange</th>
                        <th>Pair</th>
                        <th>Volume</th>
                        <th>Price</th>
                      </tr>
                      {this.state.pairdataresult}

                    </table>
                  </div>
                </div>
              }

              {_markets.widget_symbol !== 'no' ?
                <div className="col-lg-5 col-md-12">
                  <div className="token-summery-list" style={{ 'textAlign': 'center' }}>
                    <Iframe url={this.state.widgeturl}
                      id="myId"
                      className="myClassname detail-chart1"
                      display="initial"
                      position="relative" frameBorder="0" />
                  </div>
                </div> : ''
              }

            </div>
          </div> */}

          <div className="markets-graph">
            <h5><Trans>Top</Trans> {_markets.symbol_upper} <Trans>Markets</Trans></h5>

            <div className="markets-graph-inner">

              <div className="row ">

                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="markets-circle-graph">
                    <Iframe url={this.state.api_url + "/pie_chart/" + this.state.cryptoId + '/' + this.state.showCurrency}
                      width="600px"
                      height="450px"
                      id="myId"
                      className="myClassname"
                      display="initial"
                      position="relative" frameBorder="0" />
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="chart-content">
                    <Iframe url={this.state.widgeturl}
                      id="myId"
                      className="myClassname detail-chart1"
                      display="initial"
                      position="relative" frameBorder="0" />
                  </div>
                </div>

              </div>
              <div class="row">
                <div className="col-xl-9 col-lg-9 col-md-12">
                  <div className="chart-content">
                    <ul>
                      {this.state.my_markets}
                    </ul>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

        <section className="latest-news-services">
          <div className="container">
            <h2 className="section-title wow bounceInDown" data-wow-delay="0.4s">Latest <span className="underline"><Trans>News</Trans></span></h2>
            <div className="intro wow bounceInDown" data-wow-delay="0.5s"><Trans>The latest breaking news around crypto world</Trans></div>
            <div className="row">
              {this.state.latestnewsData}
            </div>
            <div className="clearfix">&nbsp;</div>
            {this.state.total_news_length !== this.state.current_news_length &&
              <div className="text-center">
                <a href="#!" className="btn btn-primary btn-lg" onClick={() => { this.loadMoreNews() }}><span><Trans>Load More</Trans></span></a>
              </div>
            }
          </div>
        </section>
<NewFooter />

      </section>
    )
  }
}
export default withTranslation('translations')(detail);